import React from 'react'

// @material-ui/core components
import { withStyles } from '@mui/styles'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import Select from '@mui/material/Select'

// core components
import landingPageStyle from '../../assets/jss/material-kit-react/views/landingPage.jsx'

import { shareCalculations } from '../../data/App'

class MarketShareMethodPicker extends React.Component {
  render() {
    const onChange =
      this.props.onChange ||
      function () {
        console.log('onChange not registered')
      }

    return (
      <FormControl>
        <InputLabel htmlFor="marketShareMethod">Calculation Type</InputLabel>
        <Select
          native
          style={{ color: '#eeeeee' }}
          value={this.props.value}
          onChange={onChange}
          inputProps={{
            name: 'marketShareMethod',
            id: 'marketShareMethod'
          }}
        >
          {shareCalculations.map((c, i) => {
            return (
              <option style={{ background: '#303030' }} value={c.dataMember} key={i}>
                {c.title}
              </option>
            )
          })}
        </Select>
      </FormControl>
    )
  }
}

export default withStyles(landingPageStyle)(MarketShareMethodPicker)
